// Will read from the state of the GenInterestCommunitiesStore.
import React from 'react';
import PropTypes from 'prop-types';
import { Spin } from 'antd';
import { connectToGeneralStore } from '../Stores/GeneralStore';
import StepControlButtons from '../UI/StepControlButtons';
import { Translate } from 'react-localize-redux';

class GeneralStep extends React.Component {
	static propTypes = {
		generalState: PropTypes.object,
		nextStep: PropTypes.func,
		previousStep: PropTypes.func,
		stepManagerDirection: PropTypes.number,
	};

	render() {
		const { generalState: state } = this.props;
		const props = this.props;

		return (
			<div className="wizard-content">
				<h1>
					<Translate id="general_interest_communities" />
				</h1>
				<p>
					<Translate id="general_interest_communities_current" />
				</p>
				{this.renderJoinedCommunities(state)}
				<p className="wizard-important-note">
					<span className="bold">
						<Translate id="important_note" />:
					</span>
					&nbsp;
					<Translate id="general_interest_communities_note" />
				</p>
				<StepControlButtons
					goNext={props.nextStep}
					goBack={props.previousStep}
					nextDisabled={state.loading}
				/>
				<div className="wizard-footer" />
			</div>
		);
	}

	componentDidMount() {
		const props = this.props;
		const { generalState: state } = props;

		if (!state.loading && !this.hasCommunities(state.communities)) {
			if (props.stepManagerDirection > 0) {
				props.nextStep();
			} else {
				props.previousStep();
			}
		}
	}

	renderJoinedCommunities = state => {
		const loading = state.loading;
		const communities = state.communities;

		if (loading) {
			return (
				<Spin wrapperClassName="full-height">
					<div />
				</Spin>
			);
		}

		return (
			<ul className="wizard-list">
				{communities.map(this.renderJoinedCommunity)}
			</ul>
		);
	};

	renderJoinedCommunity = community => {
		return <li key={community.name}>{community.name}</li>;
	};

	hasCommunities = communities => communities.length > 0;
}

export default connectToGeneralStore(GeneralStep);
